import { IDealDataResponse } from '../deal/deal.types';
import { GuestSegmentTypes, GuestSpendTypes } from '../guestSegment/guestSegment.types';
import { ISpotlightDataResponse } from '../spotlight/spotlight.types';
import { CampaignSocials, ICampaignContentType, SocialContent } from './content.types';

export enum CampaignScheduleOptions {
  RIGHT_AWAY = 'rightAway',
  SCHEDULE = 'schedule',
}

export enum CampaignType {
  SPOTLIGHTS = 'Spotlights',
  ITEMS = 'Menu Items',
  EVENTS = 'Events',
  SPECIAL_DAYS = 'Special Days',
  DEALS = 'Deals',
}

export enum CampaignStatus {
  NEEDS_EDIT = 'Needs Edits',
  REVIEW = 'Sent for Review',
  REJECTED = 'Rejected',
  APPROVED = 'Approved',
  PUBLISHED = 'Published',
  COMPLETE = 'Complete',
  EXPIRED = 'Expired',
  DRAFT = 'Draft',
}

export enum CampaignChannel {
  EMAIL = 'Email',
  TEXT = 'Text',
  SOCIALS = 'Socials',
  WEBSITE = 'Website',
  ONLINE = 'Online',
  KIOSK_BANNER = 'Kiosk Banner',
  KIOSK_SCREEN = 'Kiosk Screen',
  MENU_BOARD = 'Menu Board',
  QR = 'QR',
  // POS = 'POS',
}

export enum CampaignGoal {
  INCREASE_ONLINE_ORDERS = 'Increase Online Orders',
  INCREASE_CATERING_ORDERS = 'Increase Catering Orders', //not implemented
  INCREASE_GUEST_VISITS = 'Increase Guest Visits',
  PROMOTE_GIFT_CARD_REDEMPTION = 'Promote Gift Card Redemption', //not implemented
  INCREASE_DEAL_SALES = 'Increase Deal Sales', //not implemented
  INCREASE_ITEM_SALES = 'Increase Item Sales',
}

export const CampaignGoalLabels: { [key in string]: CampaignGoal } = {
  'Online Orders': CampaignGoal.INCREASE_ONLINE_ORDERS,
  'Deal Sales': CampaignGoal.INCREASE_DEAL_SALES,
  'Guest Visits': CampaignGoal.INCREASE_GUEST_VISITS,
  'Catering Orders': CampaignGoal.INCREASE_CATERING_ORDERS,
  'Gift Card': CampaignGoal.PROMOTE_GIFT_CARD_REDEMPTION,
  'Item Sales': CampaignGoal.INCREASE_ITEM_SALES,
};

export enum MomCampaignStatusEnum {
  TO_REVIEW = 'To Review',
  REVIEWED = 'Reviewed',
}

export interface ICampaignRoi {
  campaignId: number;
  beforeDate?: Date;
  publishDate?: Date;
  endDate: Date;
  lastCount: number;
  currentCount: number;
  goal?: number;
}

export interface ICampaignDataResponse {
  id: number;
  name: string;
  reviewAfterEdit: boolean;
  channels: CampaignChannel[];
  definedGoal: CampaignGoal;
  status: CampaignStatus;
  type: CampaignType;
  content: ICampaignContentType[];
  guestSpends: GuestSpendTypes[];
  guestSegments: GuestSegmentTypes[];
  allergens: { allergenName: string }[];
  tags: { tagName: string }[];
  spotlight?: ISpotlightDataResponse;
  item?: {
    itemName: string;
    itemPicture: string;
  };
  deal?: IDealDataResponse;
  createdAt: Date;
  updatedAt: Date;
  onlineRoi?: ICampaignRoi;
  customerRoi?: ICampaignRoi;
  itemRoi?: ICampaignRoi;
}

export interface IHolidayDataResponse {
  id: number;
  name: string;
  date: string;
  description: string;
}

export interface IHolidayCreate {
  name: string;
  date: string;
  description?: string;
}

export interface ICampaignCreateRequestType {
  restaurantId: number;
  name: string;
  status?: CampaignStatus;
  step: number;
  type: CampaignType;
  dealId?: number;
  eventId?: number;
  itemId?: number;
  holidayId?: number;
  spotlightId?: number;
  customGoal?: string;
  definedGoal?: CampaignGoal;
  isAllAudience?: boolean;
  isAllSegments?: boolean;
  isAllTags?: boolean;
  guestSegments: GuestSegmentTypes[];
  guestSpends: GuestSpendTypes[];
  tags: number[];
  allergens: number[];
  channels: CampaignChannel[];
  content: ICampaignContentType[];
  schedule: Date;
}

export interface ICampaignpdateRequestType {
  restaurantId: number;
  isArchived?: boolean;
  status?: CampaignStatus.DRAFT;
}

export interface ICampaignResponseType {
  response: {
    success: boolean;
    data: { campaigns: ICampaignDataResponse[] };
    message: string;
  };
  statusCode: number;
}

export interface ICampaignRequestResponseType {
  response: {
    success: boolean;
    data: { campaign: ICampaignDataResponse | null };
    message: string;
  };
  statusCode: number;
}

export interface ICampaignContentRequestResponseType {
  response: {
    success: boolean;
    data: { content: ICampaignContentType };
    message: string;
  };
  statusCode: number;
}

export interface CampaignTag {
  id: number;
  name: string;
}

export interface CampaignEmail {
  customerId: string;
  emailAddress: string;
  businessId: number;
}

export interface ICampaignEventBridge {
  id: number;
  name: string;
  restaurantId: number;
  businessId: number;
  time: string;
  date: string;
  timezone: string;
  action: CampaignStatus.COMPLETE | CampaignStatus.PUBLISHED;

  channel?: CampaignChannel;
  emails?: CampaignEmail[];
  phoneNumbers?: string[];
  page?: number;
  emailTemplateUrl?: string;
}

export interface ISocialSqsDto extends SocialContent {
  restaurantId: number;
  social: CampaignSocials;
}

export interface CampaignEmailVariables {
  email: string;
  variables: {
    restaurant_name?: string;
    restaurant_phoneNo?: string;
    restaurant_logo?: string;
    restaurant_address?: string;
    header?: string;
    subHeader?: string;
    media_url: string;
    title: string;
    cta_url: string;
    cta_text: string;
    body: any;
    unsubscribe: string;
    facebook_url: string;
    instagram_url: string;
    tiktok_url: string;
  };
}
